import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/admins/reports.css";
import { Link, useNavigate } from "react-router-dom";
import ProtectedLink from "../confs/protected_link";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ReportPrint from "./invoices/report_print";
import PoliceReportPrint from "./invoices/police_report_print";

const ReportPage = ({
  id,
  handleToast,
  closeLoading,
  handleLoading,
  toggleHeader,
}) => {
  const dateTen = new Date();
  dateTen.setDate(dateTen.getDate() - 10);
  const [startDate, setStartDate] = useState(dateTen);
  const [endDate, setEndDate] = useState(new Date());
  const [filteredReports, setFilteredReports] = useState([]);
  const [filters, setFilters] = useState({
    roomId: "",
    guestName: "",
    checkoutStatus: "All",
  });
  const [reports, setReports] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReportPrint, setShowReportPrint] = useState(false);
  const [showPoliceReportPrint, setShowPoliceReportPrint] = useState(false);
  const [invToDelete, setInvToDelete] = useState(null);

  //Check for staff
  const staffData = JSON.parse(localStorage.getItem("staff_as"));
  const hotelData = JSON.parse(localStorage.getItem("client_is"));
const [totalCheckedInAmount, setTotalCheckedInAmount] = useState("0.00");
const [totalCheckedOutAmount, setTotalCheckedOutAmount] = useState("0.00");
const [totalPendingAmount, setTotalPendingAmount] = useState("0.00");

console.log(filteredReports);
  // Handle form submit for fetching reports
  const fetchReports = async () => {
    handleLoading();

    try {
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${id}_bookings/reports`,
        {
          startDate,
          endDate,
        }
      );
      closeLoading();
      handleToast({
        toastMsg: "Reports Fetched Successfully!!!",
        toastColor: "#4CAF50",
      });

       const sortedData = response.data.sort((a, b) => {
      return Number(a.inv_no) - Number(b.inv_no);
    });

      setReports(sortedData);
      console.log(response.data);
      setFilteredReports(sortedData);
    } catch (err) {
      if (err.code === "ECONNABORTED") {
        fetchReports();
      }
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    }
  };

  // Handle delete ivoice
  const deleteInvoice = async () => {
    handleLoading();
    try {
      await axios.delete(
        `https://api.dectwinhotel.com/api/${id}_bookings/delete-invoive/${invToDelete}`
      );
      closeLoading();
      handleToast({
        toastMsg: "Invoice Deleted Successfully!!!",
        toastColor: "#4CAF50",
      });
      setReports([]);
      setFilteredReports([]);
    } catch (err) {
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    } finally {
      setShowConfirm(false);
      setInvToDelete(null);
    }
  };

  const handleDelete = (inv_idd) => {
    setShowConfirm(true);
    setInvToDelete(inv_idd);
  };

  // Update filter state when filter inputs change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  useEffect(() => {
    const { roomId, guestName, checkoutStatus } = filters;

    const filteredData = reports.filter((report) => {
      const matchesRoomId = roomId
        ? report.room_no.toLowerCase().includes(roomId.toLowerCase())
        : true;

      // Filter by guestName if specified
      const matchesGuestName = guestName
        ? JSON.parse(report.guest_ids)
            .name[0].toLowerCase()
            .includes(guestName.toLowerCase())
        : true;

      // Filter by checkoutStatus if specified
      const matchesCheckoutStatus =
        checkoutStatus === "All"
          ? true
          : (report.checkout_status ? "Checked Out" : "Checked In") ===
            checkoutStatus;

      // Include only reports that match all criteria
      return matchesRoomId && matchesGuestName && matchesCheckoutStatus;
    });

    setFilteredReports(filteredData);
  }, [filters, reports]);

  const guests = JSON.parse(localStorage.getItem("guests"));
  // console.log(guests);

  // Function to get guest details by guestId
  const getGuestDetails = (guestId, bookings) => {
    const guest = guests.find((g) => g.id === guestId);
    if (guest) {
      if (guest.is_com) {
        guest.name = JSON.parse(bookings.guest_ids).name[0];
        var guestName = "";
        const Gname = guest.name.split(",");
        if (Gname.length > 1) {
          guestName = Gname[1];
          for (let i = 2; i < Gname.length; i++) {
            guestName = guestName + "," + Gname[i];
          }
        }
        return {
          name: Gname[0],
          guest_name: guestName,
          contact: guest.contact,
          comp_contact: guest.comp_contact ?? "",
          address: guest.address,
          is_com: guest.is_com,
        };
      } else {
        return {
          name: guest.name,
          contact: guest.contact,
          address: guest.address,
          is_com: guest.is_com,
        };
      }
    } else {
      return {
        name: JSON.parse(bookings.guest_ids).name[0],
        contact: "",
      };
    }
  };


  useEffect(() => {
  const checkedInAmount = filteredReports
    .filter((booking) => !booking.checkout_status)
    .reduce(
      (sum, booking) =>
        sum +
        (parseFloat(booking.total_amount || 0) +
          parseFloat(booking.tax_amount || 0)),
      0
    )
    .toFixed(2);

  const checkedOutAmount = filteredReports
    .filter((booking) => booking.checkout_status)
    .reduce(
      (sum, booking) =>
        sum +
        (parseFloat(booking.total_amount || 0) +
          parseFloat(booking.tax_amount || 0)),
      0
    )
    .toFixed(2);

    
const totalPendingAmount = filteredReports
  .reduce((sum, booking) => {
//     const tax = calculateGSTAmount(Number(booking.total_amount), Number(booking.tax_rate));
//     console.log(tax);
//     const pending = 
//       Number(booking.total_amount || 0) -
//       Number(booking.advance_amount || 0) +
//       Number(booking.extra_charges || 0) +
//       tax;
// console.log(pending);
const pending = Number(booking.last_amount);
    return sum + pending;
  }, 0)
  .toFixed(2);

     setTotalPendingAmount(totalPendingAmount);
  setTotalCheckedInAmount(checkedInAmount);
  setTotalCheckedOutAmount(checkedOutAmount);
}, [filteredReports]);


  const calculateGSTAmount = (totalAmount, gstRate) => {
    return (totalAmount * gstRate) / 100;
  };


const exportToExcel = () => {
  if (filteredReports.length < 1) {
    return;
  }

  const formattedData = filteredReports.map((booking) => {
    const guestData = getGuestDetails(
      JSON.parse(booking.guest_ids).id[0],
      booking
    );

    return {
      "Invoice No": booking.inv_no ?? booking.booking_id,
      ...(hotelData.id === 6 && {
        "Entry No": booking.remarks,
      }),
      "Company Name": guestData.is_com ? guestData.name : "",
      "Guest Name": guestData.is_com ? guestData.guest_name : guestData.name,
      "Company GSTIN": guestData.is_com ? guestData.contact : "",
      "Guest Contact": guestData.is_com
        ? guestData.comp_contact
        : guestData.contact,
"Identity Proof": booking.guests
  .map(g => g.identity_proof || "")
  .filter(Boolean)
  .join(", "),
"Identity Doc": booking.guests
  .map(g =>
    g.identity_doc
      ? `https://api.dectwinhotel.com/uploads/${g.identity_doc}`
      : ""
  )
  .filter(Boolean)
  .join(", "),
      "Room No": booking.room_no,
      "From Location": booking.from_location,
      "To Location": booking.to_location,
      "Check In Date": booking.from_date,
      "Check Out Date": booking.to_date,
      Status: booking.checkout_status ? "Checked Out" : "Checked In",
      "Bill Amount": booking.total_amount,
      "GST Amount": booking.tax_amount,
      SGST: `${(booking.tax_amount / 2).toFixed(2)}(${(
        booking.tax_rate / 2
      ).toFixed(2)}%)`,
      CGST: `${(booking.tax_amount / 2).toFixed(2)}(${(
        booking.tax_rate / 2
      ).toFixed(2)}%)`,
      "Total Amount":
        (
          parseFloat(booking.total_amount) + parseFloat(booking.tax_amount)
        ).toFixed(0) + ".00",
      "Food Bill": booking.food_order_total,
      "Food GST Amount": booking.food_tax_amount,
      "Food SGST": `${(booking.food_tax_amount / 2).toFixed(2)}(${(
        booking.food_tax_rate / 2
      ).toFixed(2)}%)`,
      "Food CGST": `${(booking.food_tax_amount / 2).toFixed(2)}(${(
        booking.food_tax_rate / 2
      ).toFixed(2)}%)`,
      "Payment Methods": booking.payment_method,
    };
  });

  // ➕ Calculate total of checked out
const totalCheckedOutAmount = filteredReports
  .filter((booking) => booking.checkout_status)
  .reduce(
    (sum, booking) =>
      sum +
      (parseFloat(booking.total_amount || 0) + parseFloat(booking.tax_amount || 0)),
    0
  )
  .toFixed(0) + ".00";

  const totalCheckedInAmount = filteredReports
  .filter((booking) => !booking.checkout_status)
  .reduce(
    (sum, booking) =>
      sum +
      (parseFloat(booking.total_amount || 0) + parseFloat(booking.tax_amount || 0)),
    0
  )
  .toFixed(0) + ".00";

    formattedData.push({});
    formattedData.push({});
  // ➕ Add summary row
  formattedData.push({
  "Invoice No": "", // empty cells
  ...(hotelData.id === 6 && { "Entry No": "" }),
  "Guest Name": "Total (Checked In)",
  "Total Amount": totalCheckedInAmount,
});

  formattedData.push({
    "Invoice No": "", // empty cells
    ...(hotelData.id === 6 && { "Entry No": "" }),
    "Guest Name": "Total (Checked Out)",
    "Total Amount": totalCheckedOutAmount,
  });
  

      const workbook = XLSX.utils.book_new();

    // Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Make headings bold
    const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = headerRange.s.c; C <= headerRange.e.c; C++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
       worksheet[cellAddress].s = {
    font: {
      bold: true,
      color: { rgb: "FFFFFF" }, // White text
    },
    fill: {
      fgColor: { rgb: "800080" }, // Purple background
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
  };
}

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Hotel-Report");

    // Generate Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    // Save Excel file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Hotel-Report.xlsx");
};


const exportPoliceToExcel = () => {
  if (filteredReports.length < 1) return;

  const formattedData = filteredReports.map((booking) => {
    const guestData = getGuestDetails(
      JSON.parse(booking.guest_ids).id[0],
      booking
    );

    return {
      "Invoice No": booking.inv_no ?? booking.booking_id,
      ...(hotelData.id === 6 && { "Entry No": booking.remarks }),
      "Company Name": guestData.is_com ? guestData.name : "",
      // "Guest Name": guestData.is_com ? guestData.guest_name : guestData.name,
  "Guest Name": booking.guests.map(g => g.name).join(", "),
  "Guest Contact": booking.guests.map(g => g.contact).join(", "),
        // "Company GSTIN": guestData.is_com ? guestData.contact : "",
      // "Guest Contact": guestData.is_com ? guestData.comp_contact : guestData.contact,
  "Id Proof": booking.guests.map(g => g.identity_proof).join(", "),
  "Address": booking.guests.map(g => g.address).join(", "),
  "Gender": booking.guests.map(g => g.gender).join(", "),
        "Room No": booking.room_no,
        "From Location": booking.from_location,
        "To Location": booking.to_location,
      "Check In Date": booking.from_date,
      "Check Out Date": booking.to_date,
    };
  });

  const colCount = Object.keys(formattedData[0]).length;

  const worksheet = XLSX.utils.json_to_sheet(formattedData, { origin: 4 }); 
  // Start data from row 5 (0-based index)

  // Add hotel name in A1, merged across columns
  worksheet["A1"] = { t: "s", v: hotelData.business_name };
  worksheet["A2"] = {
    t: "s",
    v: `Phone: ${hotelData.contact || "-"} | GST: ${hotelData.gstin || "-"} | FSSAI: ${hotelData.fssai || "-"} | License: ${hotelData.oyo_reg || "-"}`
  };

  // Add date range in A3, merged across columns
  worksheet["A3"] = {
    t: "s",
    v: `From: ${new Date(startDate).toLocaleDateString()} To: ${new Date(endDate).toLocaleDateString()}`
  };

  // Merge hotel name, info, and date range across columns
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }, // hotel name
    { s: { r: 1, c: 0 }, e: { r: 1, c: colCount - 1 } }, // hotel info
    { s: { r: 2, c: 0 }, e: { r: 2, c: colCount - 1 } }, // date range
  ];

  // Style rows
  worksheet["A1"].s = { font: { bold: true, sz: 18 }, alignment: { horizontal: "center" } };
  worksheet["A2"].s = { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } };
  worksheet["A3"].s = { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } };

  // Style headers (row 5, zero-based)
  for (let c = 0; c < colCount; c++) {
    const cell = XLSX.utils.encode_cell({ r: 4, c });
    if (worksheet[cell]) {
      worksheet[cell].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "800080" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Police-Hotel-Report");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: true });
  saveAs(new Blob([excelBuffer], { type: "application/octet-stream" }), "Police-Hotel-Report.xlsx");
};


  return (
    <section
      style={{
        backgroundColor: "#282c34",
        padding: "4rem 1rem",
      }}
    >
      {!showReportPrint && !showPoliceReportPrint && (
        <div className="reports-page">
          <div className="position-absolute" style={{ right: "28px" }}>
                                    <button
              style={{ backgroundColor: "orange", }}
              className="fetch-btn"
                          onClick={() => {
                if (filteredReports.length < 1) {
                  handleToast({
                    toastMsg: "No Report to Print!!!",
                    toastColor: "#FF0000",
                  });
                  return;
                }
                setShowPoliceReportPrint(true);
                toggleHeader();
              }}
            >
              Police Pdf &nbsp; <i className="fas fa-file-pdf"></i>
            </button>
                        <button
              style={{ backgroundColor: "purple", marginLeft: "20px" }}
              className="fetch-btn"
              onClick={exportPoliceToExcel}
            >
              Police Excel &nbsp; <i className="fas fa-file-excel"></i>
            </button>

            <button
              style={{ backgroundColor: "#cc0000", marginLeft: "20px" }}
              className="fetch-btn"
              onClick={() => {
                if (filteredReports.length < 1) {
                  handleToast({
                    toastMsg: "No Report to Print!!!",
                    toastColor: "#FF0000",
                  });
                  return;
                }
                setShowReportPrint(true);
                toggleHeader();
              }}
            >
              Print Report &nbsp; <i className="fas fa-file-pdf"></i>
            </button>

            <button
              style={{ backgroundColor: "#008800", marginLeft: "20px" }}
              className="fetch-btn"
              onClick={exportToExcel}
            >
              Download Excel &nbsp; <i className="fas fa-file-excel"></i>
            </button>
          </div>

          <h2 className="text-start">View Reports</h2>
          <div className="row my-3">
            <div className="col-lg-4 col-12 my-2">
              <label>Date Range:</label>
              <div className="date-picker">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
  dateFormat="dd/MM/yyyy"                />
                <span>to</span>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
  dateFormat="dd/MM/yyyy"                />
              </div>
            </div>

            <div className="col-lg-2 col-12 my-2">
              <label>Room Number:</label>
              <input
                type="text"
                name="roomId"
                value={filters.roomId}
                onChange={handleFilterChange}
                placeholder="Enter room number"
              />
            </div>

            <div className="col-lg-2 col-12 my-2">
              <label>Guest Name:</label>
              <input
                type="text"
                name="guestName"
                value={filters.guestName}
                onChange={handleFilterChange}
                placeholder="Enter guest name"
              />
            </div>

            <div className="col-lg-2 col-12 my-2">
              <label>Status:</label>
              <select
                name="checkoutStatus"
                onChange={handleFilterChange}
                value={filters.checkoutStatus}
              >
                <option value="All">All</option>
                <option value="Checked In">Checked In</option>
                <option value="Checked Out">Checked Out</option>
                {/* <option value="advance-booking">Advance Booking</option> */}
              </select>
            </div>

            <div className="col-lg-2 col-12 my-2 pt-4">
              <button className="fetch-btn mt-2" onClick={fetchReports}>
                Fetch Reports
              </button>
            </div>
          </div>

<div className="row mb-2">
<p className="col-lg-9" style={{fontWeight: "bold", margin: 0 }}>
  Total (Checked In): ₹{totalCheckedInAmount} &nbsp;|&nbsp; Total (Checked Out): ₹{totalCheckedOutAmount}
</p>
<p className="col-lg-3" style={{fontWeight: "bold", margin: 0 }}>
  Pending Amount : ₹{totalPendingAmount}
</p>
{/* <div className=" col-lg-2">
<button className="fetch-btn" onClick={() => navigate('/admin/settlement-report')}>View Settlement</button></div> */}
</div>

          {reports.length > 0 && (
            <div className="table-responsive">
              <table className="reports-table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Guest Name</th>
                    <th>Room No</th>
                    <th>Check-in Date</th>
                    <th>Check-out Date</th>
                    <th>Status</th>
                    <th>Room Rent</th>
                    <th>GST Amount</th>
                    <th>Total Amount</th>
                    <th>Activity</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredReports.map((report) => (
                    <tr key={report.booking_id}>
                      <td>{report.inv_no ?? report.booking_id}</td>
                      <td>{JSON.parse(report.guest_ids).name[0]}
                          <br />{report.guests.map((g, i) => (
    <span className="text-primary" style={{cursor: 'pointer'}} onClick={() => window.open(`https://api.dectwinhotel.com/uploads/${g.identity_doc}`, '_blank')} key={i}>{g.identity_doc != null ? <i class="fa-solid fa-link"></i> : ''}</span>
  ))}
                      </td>
                      <td>{report.room_no}</td>
                      <td>{new Date(report.from_date).toLocaleString()}</td>
                      <td>{new Date(report.to_date).toLocaleString()}</td>
                      <td>
                        {report.checkout_status ? "Checked Out" : "Checked In"}
                      </td>
                      <td>₹{report.total_amount}</td>
                      <td>₹{report.tax_amount}</td>
                      <td>
                        ₹
                        {(
                          parseFloat(report.total_amount) +
                          parseFloat(report.tax_amount)
                        ).toFixed(2)}
                      </td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          {report.checkout_status ? (
                            <>
                              <Link to="/admin/reprint" state={report}>
                                <i
                                  title="Print Invoice"
                                  className="fa fa-file"
                                ></i>
                              </Link>
                              &nbsp;
                              <ProtectedLink
                                staffData={staffData}
                                hotelData={hotelData}
                                report={report}
                                handleToast={handleToast}
                              />
                              &nbsp;
                              {!staffData && (
                                <i
                                  style={{
                                    fontSize: "18px",
                                    color: "black",
                                    cursor: "pointer",
                                  }}
                                  title="Delete Invoice"
                                  className="fa fa-trash"
                                  onClick={() => {
                                    handleDelete(report.booking_id);
                                  }}
                                ></i>
                              )}
                            </>
                          ) : (
                            <>
                              <i
                                title="Re-print: Only after check out"
                                className="fa fa-file"
                              ></i>
                              &nbsp;
                              <i
                                title="Edit Invoice: Only after check out"
                                className="fa fa-edit"
                              ></i>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      {showConfirm && (
        <div className="modal">
          <div style={{ textAlign: "center" }} className="modal-content">
            <p>Are you sure you want to delete this invoice?</p>
            <div className="d-flex justify-content-center">
              <button onClick={deleteInvoice}>Yes</button>
              &nbsp;&nbsp;&nbsp;
              <button onClick={() => setShowConfirm(false)}>No</button>
            </div>
          </div>
        </div>
      )}
      {showReportPrint && (
        <ReportPrint
          id={hotelData.id}
          reports={filteredReports}
          toggleHeader={toggleHeader}
          setShowReportPrint = {setShowReportPrint}
        />
      )}

            {showPoliceReportPrint && (
        <PoliceReportPrint
          id={hotelData.id}
          reports={filteredReports}
          toggleHeader={toggleHeader}
          startDate = {startDate}
          endDate = {endDate}
          setShowPoliceReportPrint = {setShowPoliceReportPrint}
        />
      )}
    </section>
  );
};

export default ReportPage;
